<template>
  <mi-dialog
    class="combinations-check-details-modal"
    :model-value="modelValue"
    persistent
    @update:model-value="emitUpdateModelValue"
  >
    <h5 class="combinations-check-details-modal__title q-ma-none">
      MULTIPLE AMBIGUOUS RESULTS
    </h5>

    <p class="combinations-check-details-modal__description">
      This table has multiple ambiguous rows.
      <br />
      Choose how many results to check at once:
    </p>

    <div class="combinations-check-details-modal__options">
      <mi-radio
        v-for="option in checkDetailsOptions"
        :key="option.key"
        v-model="checkDetailsOptionChosen"
        :val="option.key"
        color="accent"
        :label="option.label"
        class="combinations-check-details-modal__radio"
      ></mi-radio>
    </div>

    <template #actions>
      <div class="combinations-check-details-modal__footer">
        <mi-checkbox
          v-model="dontShowAgain"
          size="22px"
          class="combinations-check-details-modal__checkbox"
        >
          Don’t show this again in this table
        </mi-checkbox>

        <div class="combinations-check-details-modal__buttons">
          <mi-btn
            class="combinations-check-details-modal__cancel"
            flat
            @click="onCancel"
          >
            Cancel
          </mi-btn>

          <mi-btn
            class="combinations-check-details-modal__confirm"
            type="button"
            color="accent"
            @click="confirmCheckDetails"
          >
            Check details
          </mi-btn>
        </div>
      </div>
    </template>
  </mi-dialog>
</template>

<script>
  import { ref } from 'vue'
  import MiCheckbox from '@/packages/@mi-library/MiCheckbox/MiCheckbox.vue'
  import MiRadio from '@/packages/@mi-library/MiRadio/MiRadio.vue'

  export default {
    name: 'CombinationsCheckDetailsModal',
    components: {
      MiRadio,
      MiCheckbox
    },
    props: {
      modelValue: {
        type: Boolean,
        required: true
      }
    },
    emits: ['update:model-value', 'confirm'],
    setup(props, { emit }) {
      const checkDetailsOptions = ref([
        {
          key: 'row',
          label: 'This row only'
        },
        {
          key: 'bulk',
          label: 'All ambiguous results'
        }
      ])

      const checkDetailsOptionChosen = ref('row')
      const dontShowAgain = ref(false)

      const emitUpdateModelValue = value => {
        emit('update:model-value', value)
      }

      const onCancel = () => {
        emit('update:model-value', false)
      }

      const confirmCheckDetails = () => {
        emit('confirm', {
          mode: checkDetailsOptionChosen.value,
          dontShowAgain: dontShowAgain.value
        })

        emit('update:model-value', false)
      }

      return {
        checkDetailsOptions,
        checkDetailsOptionChosen,
        dontShowAgain,
        emitUpdateModelValue,
        onCancel,
        confirmCheckDetails
      }
    }
  }
</script>

<style lang="scss">
  .combinations-check-details-modal {
    .q-dialog__inner > .mi-card {
      width: 466px;
      max-width: 466px;
      min-width: 466px;
    }

    &__description {
      margin-top: 10px;
      font-size: 12px;
    }

    &__options {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin: 36px 0 20px;
    }

    &__radio {
      font-size: 26px;

      ::v-deep(.q-radio__inner) {
        width: 34px;
        height: 34px;
        min-width: 34px;
        margin-right: 14px;
      }

      ::v-deep(.q-radio__label) {
        font-size: 26px;
        line-height: 32px;
      }
    }

    &__footer {
      display: grid;
      grid-template-columns: minmax(0, 1fr) auto;
      align-items: center;
      width: 100%;
    }

    &__checkbox {
      ::v-deep(.q-checkbox__label) {
        font-size: 12px;
      }

      ::v-deep(.q-checkbox__inner) {
        width: 5px;
      }
    }

    &__buttons {
      display: flex;
      align-items: center;
      gap: 16px;
    }

    &__cancel {
      font-size: 12px;
      font-weight: 700;
    }

    &__confirm {
      height: 35px;
      font-size: 12px;
      font-weight: 700;
    }
  }

  @media (max-width: $mi-responsive-large-width) {
    .combinations-check-details-modal {
      .q-dialog__inner > .mi-card {
        width: 466px;
        max-width: 466px;
      }
    }
  }

  @media (max-width: $mi-responsive-medium-width) {
    .combinations-check-details-modal {
      .q-dialog__inner > .mi-card {
        width: 466px;
        max-width: 466px;
        min-width: unset;
        padding: 10px;
      }

      &__footer {
        grid-template-columns: 1fr;
        align-items: flex-start;
      }

      &__buttons {
        justify-content: flex-end;
        width: 100%;
      }

      &__confirm {
        min-width: 160px;
      }
    }
  }
</style>
